import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../../routes/Route.name";
import {
  actionDragQuiz,
  actionFetchQuiz,
  actionSetPageQuiz,
} from "../../../actions/Quiz.action";
import history from "../../../libs/history.utils";
import { serviceUpdateQuizPriority } from "../../../services/Quiz.service";
import debounce from "lodash.debounce";

const useQuizListHook = ({}) => {
  const [editData, setEditData] = useState(null);
  const [isSidePanel, setSidePanel] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const isMountRef = useRef(false);
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.quiz);

  useEffect(() => {
    dispatch(
      actionFetchQuiz(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
        }
      )
    );
    isMountRef.current = true;
  }, [dispatch, query, queryData]);
  const handleSideToggle = useCallback(
    (data) => {
      setSidePanel((e) => !e);
      if (data) {
        setEditData(data?.id);
      } else {
        setEditData(null);
      }
    },
    [setEditData, setSidePanel]
  );
  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageQuiz(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchQuiz(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      const filteredValue = value?.map((item) =>
        item?.name === "is_popular"
          ? { ...item, value: item?.value === "YES" }
          : item
      );
      queryFilter("FILTER_DATA", filteredValue);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      dispatch(actionSetPageQuiz(1));
      dispatch(
        actionFetchQuiz(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );
  const handleEdit = useCallback((data) => {
    history.push(RouteName.QUIZ_UPDATE + data?.id);
  }, []);

  const handleDetail = useCallback((data) => {
    history.push(RouteName.QUIZ_DETAIL + data?.id);
  }, []);

  const handleCreate = useCallback(() => {
    history.push(RouteName.QUIZ_CREATE);
  }, []);

  const handleCopy = useCallback((type) => {
    history.push(`${RouteName.QUIZ_UPDATE}${type?.id}`,{"is_duplicate":true});
  }, []);

  const configFilter = useMemo(() => {
    return [
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["ACTIVE", "SCHEDULED"],
      },
    ];
  }, []);

  const updatePrioirty = useCallback((all) => {
    const req = serviceUpdateQuizPriority({ data: [...all] });
    req.then((res) => {
      if (!res?.error) {
        console.log(">>>>res", res);
      }
    });
  }, []);

  const priorityDebounce = useMemo(() => {
    return debounce((e) => {
      updatePrioirty(e);
    }, 1000);
  }, []);

  const handleDrag = useCallback(
    (dragId, dragOverId) => {
      const dragIndex = all?.findIndex((item) => item?.id === dragId);
      const draggedOverIndex = all?.findIndex(
        (item) => item?.id === dragOverId
      );
      if (dragIndex >= 0 && draggedOverIndex >= 0) {
        const temp = all[dragIndex];
        all.splice(dragIndex, 1);
        all.splice(draggedOverIndex, 0, temp);
        const priority = all?.map((item, index) => {
          return {
            ...item,
            priority: index,
          };
        });
        priorityDebounce(priority);
      }
      dispatch(actionDragQuiz(dragId, dragOverId));
    },
    [all]
  );

  const handleQuiz = useCallback(() => {
    history.push(RouteName.CITY);
  }, []);

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleEdit,
    isSidePanel,
    handleSideToggle,
    editData,
    configFilter,
    handleQuiz,
    handleCreate,
    handleDetail,
    handleDrag,
    handleCopy
  };
};

export default useQuizListHook;
